import { createContext } from 'react';
import { IRouteData } from '@/routes/route.interface';

const RouteDataContext = createContext<IRouteData | undefined>(undefined);
export { RouteDataContext };
